import React, { useMemo, memo } from 'react';
import { useFieldValue } from 'Shared/utils/hooks';
import VideoPlayer from 'Shared/components/VideoPlayer/VideoPlayer';

import { exampleKudos, blankKudos } from '../../../constants';
import { isKudosExist } from '../../../utils';

import './KudosComponent.scss';

function KudosComponent() {
  const kudosFromInput = useFieldValue('kudos');
  const currentWorkspace = useFieldValue('currentWorkspace');
  const fillerKudosToUse = currentWorkspace ? blankKudos : exampleKudos;
  const kudos = isKudosExist(kudosFromInput) ? kudosFromInput : fillerKudosToUse;

  const likeThatVideo = kudos.likeThatVideo;
  const videoSrc = useMemo(
    () => (likeThatVideo?.file ? window.URL.createObjectURL(likeThatVideo.file) : likeThatVideo?.url || null),
    [likeThatVideo]
  );

  return (
    <div className="d-flex flex-column ">
      <div className="d-flex mb-2 align-items-center justify-content-between">
        <p className="m-0">You gave {(currentWorkspace.fullName || '').split(' ')[0]} kudos!</p>
        {kudos === exampleKudos ? <div className="badge badge-success">Example Kudos</div> : null}
      </div>
      <div className="border shadow-sm rounded d-flex flex-column align-items-center p-3">
        {videoSrc ? (
          <VideoPlayer
            audioOnly={likeThatVideo.audioOnly}
            videoID={likeThatVideo.videoID || 13}
            withoutTranscription
            previewImageURL={likeThatVideo.previewImageUrl || likeThatVideo.preview}
            sources={[videoSrc]}
            className="onboarding-kudos-video"
          />
        ) : null}
        {kudos.gifUrl?.fixed_width?.url ? (
          <img className="mb-sm-1 mb-1 onboarding-kudos-component-gif" src={kudos.gifUrl?.fixed_width?.url} alt="" />
        ) : (
          <div className="onboarding-kudos-empty-gif" />
        )}
        {kudos.likeThatText ? (
          <p className="mb-0">{kudos.likeThatText}</p>
        ) : (
          <>
            <div className="onboarding-kudos-empty-text" />
            <div className="onboarding-kudos-empty-text" />
          </>
        )}
      </div>
    </div>
  );
}

export default memo(KudosComponent);
